import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const pulseShadow = keyframes`
  0% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.7), 0 0 10px rgba(137, 121, 205, 0.7); }
  50% { text-shadow: 0 0 8px rgba(255, 255, 255, 0.9), 0 0 20px rgba(137, 121, 205, 1); }
  100% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.7), 0 0 10px rgba(137, 121, 205, 0.7); }
`;

const AnimatedName = styled.span`
  color: #FFFFFF;
  font-weight: bold;
  animation: ${pulseShadow} 3s infinite;
  transition: transform 0.3s ease;
  display: inline-block;
  letter-spacing: 0.5px;
  
  &:hover {
    transform: scale(1.05);
    text-shadow: 0 0 10px rgba(255, 255, 255, 1), 0 0 25px rgba(137, 121, 205, 1);
  }
`;

// Responsive Footer Container
const FooterContainer = styled.div`
  height: 50px;
  background: hsla(259, 48%, 54%, 1);
  padding: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
  
  @media (max-width: 768px) {
    position: relative;
    height: auto;
    padding: 1rem;
    margin-top: 1rem;
    font-size: 0.9rem;
  }
  
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const FooterLink = styled.a`
  color: #FFFFFF;
  text-decoration: none;
  margin: 0 10px;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
    color: #FFFFFF;
  }
  
  @media (max-width: 576px) {
    margin: 5px;
  }
`;

const Footer = () => {
  const [ipAddress, setIpAddress] = useState('Loading...');
  const [ipError, setIpError] = useState(false);
  
  useEffect(() => {
    // Fetch the user's IP address
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIpAddress(data.ip))
      .catch(error => {
        console.error('Error fetching IP:', error);
        setIpError(true);
      });
  }, []);

  const disclaimerStyle = {
    fontSize: '0.7rem',
    color: '#ffffff',
    fontWeight: 'bold',
    marginBottom: '5px'
  };

  return (
    <FooterContainer className="footer">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={disclaimerStyle}>
          DevToolStatio works only in your browser, your data is secured
        </div>
        <div className="footer-text">
          {!ipError && `IP: ${ipAddress} • `}@2025 Powered by <AnimatedName>Vishal Kumar Aruru</AnimatedName>
        </div>
      </div>
    </FooterContainer>
  );
};

export default Footer;